export default "__VITE_ASSET__zHDpF2aI__"